import styled from 'styled-components';

import { HeaderH2style } from '../../uiComponents';
import { Grid, Spacing, Color, Media } from '../../theme';
import { ContainerData } from './bigTextHeader.types';

export const Container = styled.div<ContainerData>`
  background-color: ${(props: ContainerData) => props.backgroundColor ? props.backgroundColor : Color.veryLightGrey2};
  position: relative;
`;

export const InnerContainer = styled.div`
  max-width: ${Grid.DesktopWide};
  margin: 0 auto;
`;

export const Header = styled.h1`
  ${HeaderH2style}
  max-width: ${Grid.DesktopWide};
  padding: 100px ${Spacing.DesktopWide} 145px;
  ${Media.desktop`
    padding: 100px ${Spacing.Desktop} 145px;
  `}
  ${Media.tablet`
    padding: 100px ${Spacing.Tablet} 145px;
  `}
`;

export const HalfBox = styled.div`
  width: 50%;
  background-color: ${Color.white};
  height: 45px;
  position: absolute;
  bottom: 0;
  right: 0;
`;
